export const invalidPostcodeRedirectURL =
  "https://install.chargedev.co.uk/evhs2/signup?organization_id=cev&key_account_id=7CCAA1DB-7E66-3946-8227-5AD25D607724&job_type_id=861AB278-F1E8-4AC0-96AA-4EBB430FCBEF";
